import type { HTMLAttributes, JSX } from 'react';

import { cn } from '../lib/cn';
import { usePrefersReducedMotion } from '../lib/use-prefers-reduced-motion';

export type SkeletonProps = HTMLAttributes<HTMLDivElement>;

/**
 * A loading placeholder, in place of "Cargando…" text.
 *
 * Checks prefers-reduced-motion directly rather than relying solely on the
 * global @media rule in styles.css: that rule zeroes animation-duration on
 * an element that still carries animate-pulse in its className, which is
 * enough visually but leaves the class present for anything (a test, a
 * future consumer) that inspects it directly.
 */
export function Skeleton({ className, ...props }: SkeletonProps): JSX.Element {
  const prefersReducedMotion = usePrefersReducedMotion();

  return (
    <div
      className={cn(
        'rounded-md bg-slate-200',
        prefersReducedMotion ? null : 'animate-pulse',
        className,
      )}
      {...props}
    />
  );
}
